import React, { FC, useMemo, ReactNode } from 'react';
import { TaskContext, TaskNavContext } from './context';
import { useLoadTask, useTaskNavCtx } from './hooks';

interface Props {
  children: ReactNode;
}
export const TaskNavProvider: FC<Props> = ({ children }) => {
  const value = useTaskNavCtx();

  return <TaskNavContext.Provider value={value}>{children}</TaskNavContext.Provider>;
};

export const TaskProvider: FC<Props> = ({ children }) => {
  const { data, loading } = useLoadTask();
  const value = useMemo(() => ({ data: data ?? null, loading }), [data, loading]);

  return <TaskContext.Provider value={value}>{children}</TaskContext.Provider>;
};
